module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "pn"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "pep"
  }, [_vm._v("In early 2001, having saddled the pharmaceutical giant with huge debt and cut its workforce by a third, Vaughan’s Oberon Capital Group sold Eiben-Chemcorp for a profit of $457 million. It appears, however, that Oberon did this in the full knowledge that an R&D scandal involving leaked samples of a trial “smart drug” was brewing at Eiben. What is more—and is perhaps more shocking—they then shorted the buyer’s stock in order to make a double killing on the transaction.")]), _vm._v(" "), _c('p', {
    staticClass: "pepc"
  }, [_vm._v("—"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("House of Vaughan")]), _vm._v(" (p. 23)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef8734c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0